import { Pipe, PipeTransform } from "@angular/core";
import { DsSelectOption, DsSelectValue } from "@app2/shared/components/ds-select.component";

// Takes any array and returns a new array of type DsSelectOption[] to be used for <ds-select>
// Also, can take the name of the input array's fields as the key/value for the new array
@Pipe({ name: "mapStringToPair" })
export class MapStringToPairPipe implements PipeTransform {
    transform<V extends DsSelectValue>(arr: any[], key?: string, value?: string): DsSelectOption<V>[]  {
        if (key && value) {
            return arr.map(item => ({ key: item[key] , value: item[value] }));
        } else {
            return arr.map(item => ({ key: item , value: item }));
        }
    }
}
